<div class="done-close-box">
    <div class="done-close-box-main {{type}}">
      <em class="done-icon"></em>
      <h2>{{message}}</h2>
      <p class="txt">{{text}}</p>
    </div>
</div>
